import React from 'react';
import InputType from './ComponentsTpes/InputType';

const LoopSensor = ({  fieldsData, componentSourceOptions ,
    selectedPorts, setSelectedPorts, savedData, setSavedData}) => {

    const selectOptions = (key, value) => {
        setSavedData(prevData => {
            return {
                ...prevData,
                Loop_sensor:{
                    ...prevData.Loop_sensor,
                    [key]: value
                }
            }
        })
    }

    return (<InputType
        setSelectedPorts={setSelectedPorts}
        selectedPorts={selectedPorts}
        source={componentSourceOptions.inputsData}
        selectOptions={selectOptions}
        component_source={savedData.Loop_sensor.component_source.value}
        condition={savedData.Loop_sensor.condition}
        input={savedData.Loop_sensor.input}
        name={savedData.Loop_sensor.name}
        fieldsData={fieldsData}
    />)
}

export default LoopSensor;